module.exports = __webpack_public_path__ + "static/media/offline-3.d07090ba.jpg";